import O1HD from "../../../engines/gameEngine";
import getOneBundle, { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../BundleResourceConfig";
import { bannerData, bannerInterface } from "../config/bannerConst";
import bannerPrefab from "../prefab/banner/bannerPrefab";
import NormalGameManager from "./NormalGameManager";

export default class bannerManager{
    //normalGameManager引用
    public gameManager:NormalGameManager = null;

    //banner初始数据
    private _initStr:string = "";

    //banner存数据的key
    private _banner_save_data_key:string = "banner-manager-save-key";

    //banner预制体
    bannerPrefab:cc.Prefab = null;

    //当前显示的banner节点数量
    bannerCount:number = 0;

    //banner最大显示数量
    maxBannerCount:number = 3;

    //banner节点显示的Y坐标  X坐标默认显示在屏幕最左边 如需改变请后续实现
    bannerYPosAry:number[] = [100,200,300];

    // banner节点数组
    bannerNodesAry:cc.Node[] = [];

    //数据接口 用来存储数据
    _data:bannerData = {
        bannerQueue: []
    }

    constructor(gameManager:NormalGameManager){
        this.gameManager = gameManager;
        this.bannerNodesAry = new Array<cc.Node>(this.maxBannerCount).fill(null);
        //首次进入直接读取存的数据
        this.loadData();
        //加载banner预制体
        this.loadBannerPrefab();
    }

    loadData(){
        this._initStr = JSON.stringify(this._data);
        let dataStr = O1HD.getServices().localStorageSrv.getStorage(this._banner_save_data_key) || this._initStr;
        if(dataStr == ""){
            dataStr = this._initStr;
        }
        let data = JSON.parse(dataStr);
        this.setData(data);

    }

    getData(){
        return this._data;
    }

    setData(data:bannerData,isPlus:boolean = false){
        for (let key in data) {
            let k = data[key];
            if (k != null) {
                if (k instanceof Array) {
                    if (isPlus) {
                        this._data[key] = this._data[key].concat(k);
                    } else {
                        this._data[key] = [].concat(k);
                    }
                } else {
                    if (isPlus) {
                        this._data[key] += k;
                    } else {
                        this._data[key] = k;
                    }
                }
            }
        }
        this.writeData();
    }

    writeData(){
        O1HD.getServices().localStorageSrv.setStorage(this._banner_save_data_key,JSON.stringify(this._data));
    }

    resetManager(){
        this.setData(JSON.parse(this._initStr));
    }

    async loadBannerPrefab(){
        // 读取完数据之后如果有需要展示的横幅则直接展示横幅
        let url:string = "prefab/bannerPrefab";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.bannerGameBundle,url);
        this.bannerPrefab = prefab;
        this.showBanner();
    }

    addOneBanner(bannerExplain:string,peopleId:string){
        let banner:bannerInterface = {
            peopleId: peopleId,
            explain: bannerExplain
        }
        this.setData({bannerQueue:[banner]},true);
        this.showBanner();
    }

    showBanner(){
        if(!this.bannerPrefab){
            return;
        }
        for(let i =0;i<this.maxBannerCount;i++){
            let index = this.getOneIdleIndex();
            if(index > -1){
                let bannerData = this.getData().bannerQueue.shift();
                this.writeData();
                if(bannerData){
                    let yPos:number = this.bannerYPosAry[index];
                    let bannerNode:cc.Node = cc.instantiate(this.bannerPrefab);
                    let bs = bannerNode.getComponent(bannerPrefab);
                    bs.bindData(bannerData);
                    this.bannerNodesAry[index] = bannerNode;
                    O1HD.getModules().uiControlModule.getUIRoot().addChild(bannerNode);
                    bannerNode.setPosition(375,yPos);
                    this.bannerAni(bannerNode,index);
                }
            }
        }
    }

    /**
     * banner动画
     * @param bannerNode banner节点
     * @param posIndex banner位置信息
     */
    async bannerAni(bannerNode:cc.Node,posIndex:number){
        if(bannerNode && bannerNode.isValid){
            let bs = bannerNode.getComponent(bannerPrefab);
            await bs.bannerAni();
            this.bannerNodesAry[posIndex] = null;
            this.showBanner();
        }
    }

    getOneIdleIndex(){
        let index = this.bannerNodesAry.findIndex((value:cc.Node) =>{
            return value == null;
        });
        return index;
    }

}
